import React from 'react';

import { Box } from '@wds/box';
import { Grid } from '@wds/grid';

import useStyles from './useStyles';

export type ShadedBackgroundColorProp = 'dark1' | 'dark2' | 'dark3' | 'light1' | 'light2';

export type Props = {
  backgroundColor?: ShadedBackgroundColorProp;
  imageSource: string;
  // @todo: https://momentiveai.atlassian.net/browse/ANONWEB-5448
};

export default function EndpageImage({ backgroundColor = 'light2', imageSource }: Props): React.ReactElement {
  const { container, image } = useStyles({ backgroundColor, imageSource });
  return (
    <Box className={container}>
      <Grid noBleeds noGutters px={5}>
        <Grid.Item lg={3}>
          <></>
        </Grid.Item>
        <Grid.Item lg={6} xs={12}>
          <div className={image} data-testid="EndpageImage__ImageDiv">
            <></>
          </div>
        </Grid.Item>
        <Grid.Item lg={3}>
          <></>
        </Grid.Item>
      </Grid>
    </Box>
  );
}
